import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "path-node__item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
    class: "path-node__icon",
    style: _normalizeStyle(`background-image: url(${_ctx.path.icon})`),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.onClick())
  }, null, 4), _createElementVNode("span", {
    class: "path-node__title",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.onClick())
  }, _toDisplayString(_ctx.title), 1), _ctx.path.showClose ? (_openBlock(), _createElementBlock("a", {
    key: 0,
    href: "javascript:;",
    class: "qh-icon-delete-nav",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.onClose())
  })) : _createCommentVNode("", true)]);
}